import React, { useState, useEffect } from "react";
import { Button, Modal } from "reactstrap";
import { InputLabelAlert } from "../../layout";
import { bancoFornecedor, sendData } from "../../../helpers/auth";
import { width } from "../../../helpers/general";
import { uriList } from "../../../helpers/config";
import { connect } from "react-redux";

const TEMPO_REENVIO = 5 * 60 * 1000; // 5 minutos em milissegundos

const Form = ({ ...props }) => {
  const [codigo, setCodigo] = useState("");
  const [enviado, setEnviado] = useState(props.enviado || false);
  const [warning, setWarning] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [validado, setValidado] = useState(true);
  const [reenviar, setReenviar] = useState(false);
  const [data, setData] = useState(props.data || {})
  const [ultimoEnvio, setUltimoEnvio] = useState(null);
  const [primeiraVez, setPrimeiraVez] = useState(true);

  useEffect(() => {
    console.log("validarCodigo.useEffect: ", props.detalhes.uuid, props.proposta)
  }, []);

  useEffect(() => {
    if (!habilitado) {
      const timer = setTimeout(() => {
        setHabilitado(true);
        setPrimeiraVez(true);
      }, TEMPO_REENVIO);
      return () => clearTimeout(timer);
    }
  }, [habilitado]);

  const handleChange = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    value = value.toUpperCase().trim();
    setCodigo(value);
    setWarning(false);
    setReenviar(false);
  };

  const handleClose = () => {
    setCodigo("");
    setEnviado(false);
    setWarning(false);
    setHabilitado(true);
    setValidado(true);
    props.onCloseEv && props.onCloseEv(false);
  };

  const handleEnviar = async () => {
    setHabilitado(false);
    await sendData({
      uri: uriList("enviarCodigo"),
      content: { uuid: props.detalhes.uuid || props.proposta.uuid, ...data },
      method: "POST",
    })
      .then((res) => {
        if (res.status && parseInt(res.status) > 200) throw new Error();
        setEnviado(true);
        setValidado({});
        setUltimoEnvio(Date.now());
        setPrimeiraVez(false);
      })
      .catch((e) => {
        setHabilitado(true);
        setValidado(true);
        console.log(e.message);
        console.log(e.data);
        if (e.data) console.log(e.data.message);
        alert("Erro ao enviar código!");
      });
  };

  const handleValidar = async () => {
    if (codigo) {
      let content = { uuid: props.proposta, codigo, ...(props.data || {}), ...data };
      await sendData({ uri: uriList("validarCodigo"), content, method: "POST" })
        .then((res) => {
          console.log("validarCodigo.handleValidar: ", res)

          if (res.codigoRet == "02" && bancoFornecedor() == "cef") {
            setReenviar(true)
            setCodigo(null);
            setWarning(false);
            setReenviar(false);
          }
          if (res.status && parseInt(res.status) > 200) throw new Error();

          setValidado(true);
          if (props.onCloseEv) props.onCloseEv(true);
        })
        .catch((e) => {
          console.log("validarCodigo.handleValidar(erro): ", e)
          setValidado(true);
          setWarning(true);
          console.log(e);
        });
    } else setWarning(true);
  };

  const podeReenviar = () => {
    if (!ultimoEnvio) return true;
    return Date.now() - ultimoEnvio >= TEMPO_REENVIO;
  };

  return (
    <div
      style={{
        // border: "0.3px solid",
        width: "100%",
        minWidth: "300px",
        maxWidth: "420px", // Reduced from 600px
        margin: "0 auto",
        height: "auto",
        borderColor: "#8C8C8C",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "15px",
          width: "100%",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "15px", width: "100%" }}>
          <strong>
            <p style={{ fontSize: "23px", margin: 0 }}>{props.titulo || "Validar Proposta"}</p>
          </strong>
        </div>
        {!props.naoEnviar &&
          <div
            style={{
              marginBottom: "35px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {habilitado && (
              <button
                onClick={handleEnviar}
                disabled={!habilitado}
                style={{
                  padding: "8px 16px",
                  maxWidth: "140px", // Reduced from 200px
                  width: "100%"
                }}
              >
                {!enviado ? "Receber Código" : "Reenviar Código"}
              </button>
            )}
            {!habilitado && (
              <div style={{ color: "#8C8C8C" }}>Aguarde para Reenviar...</div>
            )}
            <div
              style={{
                fontSize: "12px",
                color: "#3E6C84",
                width: "100%",
                maxWidth: "210px", // Reduced from 300px
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              <p style={{ margin: 0 }}>
                * Você receberá um código através de SMS/email.
              </p>
            </div>
          </div>
        }
        {enviado && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "280px" }}> {/* Reduced from 400px */}
            <div style={{ marginBottom: "20px", width: "100%" }}>
              <InputLabelAlert
                type="text"
                label="Código:"
                id="codigo"
                cifrao={false}
                value={codigo}
                length={10}
                onChange={codigo}
                handle={handleChange}
                autoComplete="off"
                warning={warning}
                focus={true}
                msgErro="Código inválido ou expirado!"
              />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              width: '100%'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                width: '100%'
              }}>
                <Button color="success" onClick={handleValidar} style={{ minWidth: '70px', flex: '1' }}> {/* Reduced from 100px */}
                  Validar
                </Button>
                {(primeiraVez || habilitado) && (
                  <Button color="warning" onClick={handleEnviar} style={{ minWidth: '70px', flex: '1' }}> {/* Reduced from 100px */}
                    Reenviar
                  </Button>
                )}
              </div>
              {props.onCloseEv &&
                <Button color="secondary" onClick={props.onCloseEv} style={{ minWidth: '70px', width: '100%' }}> {/* Reduced from 100px */}
                  Fechar
                </Button>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
  };
}

export default connect(mapStateToProps)(Form);
